const initialState = { 
  loading: false,
  success: null,
  error: null
}

function updateVoucherReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_VOUCHER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'UPDATE_VOUCHER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'UPDATE_VOUCHER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default updateVoucherReducer